export default "__VITE_ASSET__CERkAEZQ__"